// 导入样式文件
import './VoiceList.less';
// 导入React钩子
import { useContext, useEffect, useState, useRef, useCallback } from 'react';
// 导入空列表图片
import empty from '@/assets/empty/space.svg';
// 导入AI语音上下文
import AivoiceContext from '@/context/AiVoiceContext';

// 导入播放和暂停图标
import ImgPlay from '@/assets/aivoices/play.svg';
import ImgPause from '@/assets/aivoices/pause.svg';
// import more from '@/assets/space/more.png';
// 导入日期格式化工具函数
import { formatDateTime } from '@/utils/dayjs';
// 导入自定义Icon组件
import Icon from '@/components/iconfont/Icon.jsx';

import PlayvoiceImg from '@/assets/aivoices/playvoice.gif';
import { useWebSocket } from '@/hooks/useWebSocket.js';
import { MessageEventType } from '@/utils/socket.js';
import message from '@/utils/message';
import { useTranslation } from 'react-i18next';
import More from '@/pages/space/components/more/More';
const MAX_LIMIT = 12;
// 定义VoiceList组件
export default function VoiceList() {
  // 从上下文中获取语音列表
  const { voiceList, setVoiceList, setUpdateTimestamp, setPupUpTime } = useContext(AivoiceContext);
  const [showMore, setShowMore] = useState(true);
  const [page, setPage] = useState(0);
  const { t } = useTranslation();
  useWebSocket(
    'RETRY_SUCCESS',
    useCallback(() => {
      setUpdateTimestamp(new Date().getTime());
    }, []),
  );
  useWebSocket(
    MessageEventType.CLONE_VOICE,
    useCallback(({ number, status }) => {
      console.log('后台推送了声音克隆消息', number, status);
      setPupUpTime(new Date().getTime());
      if (window.location.pathname !== '/space') return;
      // 判断列表中是否已存在该number的声音
      const hasNumber = voiceList.some((item) => item.number === number);
      if (!hasNumber) return;
      if (status !== 2) {
        message.success('Voice cloned successful', {
          id: 'voice',
        });
      } else {
        message.error(t('As_Edit_NullAudio'));
      }

      setVoiceList((prevList) => {
        if (prevList.length === 0) return prevList;
        if (status === 2) {
          return prevList.filter((item) => item.number !== number);
        }
        return prevList.map((item) => (item.number === number ? { ...item, status } : item));
      });
    }, []),
  );
  useEffect(() => {
    if (voiceList?.length < MAX_LIMIT || (page + 1) * MAX_LIMIT >= voiceList?.length) {
      setShowMore(false);
    } else {
      setShowMore(true);
    }
  }, [page, voiceList]);
  const getMoreData = () => {
    setPage(page + 1);
  };
  // 渲染组件
  return (
    <>
      <div className="voicelist_box">
        {voiceList.length > 0 ? (
          <ItemCard list={voiceList?.slice(0, (page + 1) * MAX_LIMIT)} />
        ) : (
          <EmptyVoiceList />
        )}
      </div>
      {showMore && <More onClick={getMoreData} top={33} />}
    </>
  );
}

// 定义ItemCard组件，用于显示语音列表项
function ItemCard({ list }) {
  const { setShowChangeNameModal, setCurrentItem, pupUpTime } = useContext(AivoiceContext);
  // 当前正在播放的音频索引
  const [playingItem, setPlayingItem] = useState({});
  const { t } = useTranslation();
  // 音频元素的引用
  const audioRef = useRef(null);
  // 初始化每个列表项的播放状态
  useEffect(() => {
    list.forEach((item) => {
      item.playFlag = false;
    });
    console.log(list, '===socketvalvalvalvalva listlist');
  }, [list, playingItem]);
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.removeEventListener('ended', handleAudioEnded);
    }
  }, [pupUpTime]);
  useEffect(() => {
    // 清理函数，用于组件卸载时移除事件监听器
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.removeEventListener('ended', handleAudioEnded);
      }
    };
  }, []);

  const handlePlayPause = (item) => {
    if (item.status === 0) return;
    if (playingItem?.number === item.number) {
      item.playFlag = false;
      audioRef.current.pause();
      setPlayingItem(null);
    } else {
      item.playFlag = true;
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.removeEventListener('ended', handleAudioEnded);
      }
      audioRef.current = new Audio(item.sampleAudio);
      audioRef.current.addEventListener('ended', handleAudioEnded);
      // audioRef.current.load();
      audioRef.current.play();
      setPlayingItem(item);
    }
  };

  const handleAudioEnded = () => {
    console.log('音频播放结束');
    setPlayingItem(null);
  };
  const handleOpenEditName = (val) => {
    setCurrentItem(val);
    setTimeout(() => {
      setShowChangeNameModal(true);
    });
  };
  // const handleOpenDelete = (val) => {
  //   setCurrentItem(val);
  //   setTimeout(() => {
  //     setShowDeleteModal(true);
  //   });
  // };
  // 渲染语音列表
  return (
    <div className="item_card">
      {list.map((item, index) => (
        <div key={index} className="card_box">
          <div className="card_top">
            <div className="playimg_box" onClick={() => handlePlayPause(item)}>
              {item.status === 0 ? (
                <div className="playimg_loading_bg">
                  <span className="loading loading-spinner text-primary"></span>
                </div>
              ) : (
                <img
                  src={item.playFlag ? ImgPlay : ImgPause}
                  style={{ opacity: item.playFlag ? 1 : 0.5 }}
                  alt=""
                />
              )}
            </div>
            <div className={`card_name ${item.status !== 0 ? 'hover_box' : ''}`}>
              <div className="text_box">
                <div className="text">{item.name}</div>
                {item.playFlag ? (
                  <img src={PlayvoiceImg} alt="" className="playvoice_img" />
                ) : (
                  <Icon name="icon-wave" className="icon-wave" />
                )}
              </div>

              {item.status === 0 ? (
                <div className="cloning">
                  {/* Voice cloning */}
                  {t('As_Clone_Cloning')}
                  <span className="spot_list cloneing_spot">
                    <span className="spot">·</span>
                    <span className="spot">·</span>
                    <span className="spot">·</span>
                  </span>
                </div>
              ) : (
                <div className="time">{formatDateTime(item.gmtCreated)}</div>
              )}
            </div>
          </div>
          <div className="card_btm">
            <button
              className="btn btn-ghost btn-sm btn_rename"
              onClick={() => {
                handleOpenEditName(item);
              }}>
              <Icon name="icon-edit" className="btn_icon" />
              {/* Rename */}
              {t('As_ProjectManage_Rename')}
            </button>
            {/* <div className="line"></div>
            <button
              className="btn btn-ghost btn-sm btn_delete"
              onClick={() => {
                handleOpenDelete(item);
              }}>
              <Icon name="icon-delete" className="btn_icon" />
              Delete
            </button> */}
          </div>
        </div>
      ))}
    </div>
  );
}

// 定义EmptyVoiceList组件，用于显示空列表状态
function EmptyVoiceList() {
  const { t } = useTranslation();
  return (
    <div className="empty_box">
      <img src={empty} alt="" />
      <div className="empty_text">{t('As_Space_MyVoiceNull1334')}</div>
      <div className="empty_text">{t('As_Space_MyVoiceNull2334')}</div>
    </div>
  );
}
